import { useState } from "react";

const BASE_ZOOM = 17;
export const useSpiderfy = (data, map) => {
  const [spiderState, setSpiderState] = useState(null);

  const getLatLng = (item) => ({
    lat: parseFloat(item.lat ?? item.latitude),
    lng: parseFloat(item.lng ?? item.longitude)
  });

  const isOverlap = (item1, item2, projection, maxDistance = 20) => {
    const p1 = projection.fromLatLngToPoint(getLatLng(item1));
    const p2 = projection.fromLatLngToPoint(getLatLng(item2));

    const scale = Math.pow(2, map.getZoom());

    const dx = (p1.x - p2.x) * scale;
    const dy = (p1.y - p2.y) * scale;

    return Math.sqrt(dx * dx + dy * dy) < maxDistance;
  };

  const getGroup = (item) => {
    if (!map) return [];

    const projection = map.getProjection();
    if (!projection) return [];

    return data.filter(d => isOverlap(item, d, projection));
  };

  const spiderfy = (items) => {
    const center = getLatLng(items[0]);
    const angleStep = (2 * Math.PI) / items.length;

    const radius = 0.0003 * Math.pow(2, BASE_ZOOM - map.getZoom());

    const markers = items.map((item, i) => {
      const angle = i * angleStep;

      return {
        ...item,
        lat: center.lat + radius * Math.cos(angle),
        lng: center.lng + radius * Math.sin(angle),
        original: center
      };
    });

    setSpiderState({
      activeGroup: items.map(i => i.id),
      markers
    });
  };

  const toggleSpiderfy = (item) => {
    const isInsideGroup = spiderState?.activeGroup?.includes(item.id);

    if (spiderState && !isInsideGroup) {
      setSpiderState(null);

      const group = getGroup(item);

      if (group.length > 1) {
        spiderfy(group);
        return { type: "spiderfy" };
      }

      return { type: "single" };
    }

    if (isInsideGroup) {
      return { type: "select" };
    }

    const group = getGroup(item);

    if (group.length > 1) {
      spiderfy(group);
      return { type: "spiderfy" };
    }

    return { type: "single" };
  };

  const markers = data.map(item => {
    if (spiderState) {
      const found = spiderState.markers.find(m => m.id === item.id);
      if (found) return found;
    }

    return {
      ...item,
      ...getLatLng(item)
    };
  });

  return {
    markers,
    spiderState,
    toggleSpiderfy,
    setSpiderState
  };
};